export const isAnyInObject = (
  hayStack: Record<string, unknown>,
  needle: string[]
): boolean => {
  const keys = Object.keys(hayStack)

  return keys.some((key) => needle.includes(key) && hayStack[key] !== undefined)
}
